import { useState, useEffect, useRef } from "react";

const useSingleCooldown = (duration = 30_000) => {
  const [isCoolingDown, setIsCoolingDown] = useState(false);
  const timerRef = useRef(null);

  const triggerCooldown = () => {
    setIsCoolingDown(true);
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      setIsCoolingDown(false);
      timerRef.current = null;
    }, duration);
  };

  useEffect(() => {
    return () => clearTimeout(timerRef.current);
  }, []);

  return { isCoolingDown, triggerCooldown };
};

export default useSingleCooldown;
